import { openSalesIQChat } from '../utils/openSalesIQChat';

export default function SupportSection() {
  return (
    <section className="t7-section t7-section--green">
      <div className="container">
        <div className="t7-cta-row">
          <div>
            <p className="t7-kicker">Real people, real answers</p>
            <h2 className="t7-title">Support that meets you where you are</h2>
            <p className="t7-lead mb-0">
              Install blocked? Tree won&apos;t open on a new PC? Sync spinning forever? Open live chat
              and we&apos;ll guide you through the fix—one clear step at a time.
            </p>
          </div>
          <div className="t7-cta-row__action">
            <button type="button" className="t7-btn t7-btn--solid" onClick={openSalesIQChat}>
              Start a Chat
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
